import React from 'react';
import styled from 'styled-components';

import { MdChevronRight as ChevronRightIcon } from 'react-icons/md';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import CtaText from 'components/ui/CtaCard';
import MaintenanceTicketSearch from 'components/shared/MaintenanceTicketSearch';
import StatusTag from 'components/ui/StatusTag';
import { getTranslatedString } from 'helpers/i18n';
import { media } from 'helpers/MediaHelper';
import { colors } from 'helpers/ColorHelper';

const StyledFormContainer = styled.div`
  margin-bottom: 30px;
  width: 100%;
`;

const StyledInternalHeader = styled.div`
  font-size: 1.5rem;
  margin-bottom: 10px;
`;

const StyledFormRow = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  ${media.mobile`
    flex-direction: column;
  `};
`;

const StyledFormRowSpaceAbove = styled.div`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  margin-top: 30px;
  ${media.mobile`
    flex-direction: column;
  `};
`;

const StyledFormItem = styled.div`
  width: 100%;
  padding: 0px 8px;
  text-align: ${(props) => props.textAlign || 'left'};
  margin: ${(props) => props.margin || '0px'};
`;

const StyledFormItemLabel = styled.div`
  margin-bottom: 5px;
`;

const StyledLinkedContainer = styled.div`
  margin-top: 15px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${colors.LIGHT_PERIWINKLE};
  background-color: ${colors.WHITE};
`;

const StyledRightButton = styled(CtaText)`
  margin-left: 10px;
  margin-top: 2.5px;
  padding: 0px;
`;

const StyledRightA = styled.a`
  float: right;
  margin-right: 10px;
`;

const ColCutoff = styled(Col)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const LinkServiceRequests = ({
  propertyId,
  selectedServiceRequests,
  handleSelectServiceRequest,
  handleUnlinkServiceRequest,
  serviceRequests,
}) => {
  const showLinkedServiceRequests = serviceRequests && serviceRequests.length > 0;
  return (
    <StyledFormContainer>
      <StyledFormRow>
        <StyledFormItem>
          <StyledInternalHeader>
            {getTranslatedString('landlordPortal.linkServiceRequests.linkServiceRequests')}
          </StyledInternalHeader>
          <StyledFormItemLabel>
            {getTranslatedString('landlordPortal.linkServiceRequests.serviceRequests')}
          </StyledFormItemLabel>
          <MaintenanceTicketSearch
            propertyIds={propertyId}
            handleSelectItem={handleSelectServiceRequest}
            selectedServiceRequests={selectedServiceRequests}
          />
        </StyledFormItem>
      </StyledFormRow>
      {showLinkedServiceRequests && (
        <StyledFormRowSpaceAbove>
          <StyledFormItem>
            <StyledInternalHeader>
              {getTranslatedString('landlordPortal.linkServiceRequests.linkedServiceRequests')}
            </StyledInternalHeader>
            {serviceRequests.map((serviceRequest) => (
              <StyledLinkedContainer key={`linked_service_request_${serviceRequest.id}`}>
                <Row gutter={16}>
                  <Col xs={24}>
                    <strong>
                      {getTranslatedString(
                        'landlordPortal.linkServiceRequests.serviceRequestNumber',
                        { ticketNumber: serviceRequest.ticket_number }
                      )}
                    </strong>
                  </Col>
                  <ColCutoff xs={16} sm={18}>
                    {serviceRequest.subject}
                  </ColCutoff>
                  <Col xs={8} sm={6}>
                    <StyledRightButton
                      type="button"
                      onClick={() => handleUnlinkServiceRequest(serviceRequest.id)}
                    >
                      {getTranslatedString('landlordPortal.linkServiceRequests.unlink')}
                    </StyledRightButton>
                    <StyledRightA
                      href={`/companies/maintenance/tickets/${serviceRequest.id}`}
                      target="_blank"
                    >
                      <ChevronRightIcon size={24} style={{ padding: 0 }} />
                    </StyledRightA>
                  </Col>
                  <Col xs={24}>
                    <StatusTag status={serviceRequest.status} />
                  </Col>
                </Row>
              </StyledLinkedContainer>
            ))}
          </StyledFormItem>
        </StyledFormRowSpaceAbove>
      )}
    </StyledFormContainer>
  );
};
